import React from 'react';
import { useLocation } from 'react-router-dom';

// Indicador de pasos (estilo kiosco): Menú → Carrito → Pago.
const STEPS = ['Menú', 'Carrito', 'Pago'];

const stepFromPath = (path) => {
    if (path === '/cart') return 1;
    if (['/order-type', '/payment-method', '/payment', '/operate-card'].includes(path)) return 2;
    return 0; // /products, /, /categories, /products/:id
};

const StepIndicator = () => {
    const { pathname } = useLocation();
    const current = stepFromPath(pathname);

    return (
        <div style={{
            flexShrink: 0, background: '#F3EFE6', padding: '12px 24px',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
            borderBottom: '1px solid #e7e0d3'
        }}>
            {STEPS.map((label, i) => {
                const done = i < current;
                const active = i === current;
                const on = done || active;
                return (
                    <React.Fragment key={label}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                            <div style={{
                                width: 32, height: 32, borderRadius: '50%',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                fontWeight: 900, fontSize: '0.95rem',
                                background: on ? '#6b7280' : '#ffffff',
                                color: on ? '#fff' : '#b3a993',
                                border: on ? 'none' : '2px solid #e0d8c9',
                            }}>
                                {done ? '✓' : i + 1}
                            </div>
                            <span style={{
                                fontWeight: 800, fontSize: '1rem',
                                color: active ? '#009542' : on ? '#6b7280' : '#b3a993',
                            }}>{label}</span>
                        </div>
                        {i < STEPS.length - 1 && (
                            <div style={{ width: 48, height: 3, borderRadius: 2, background: i < current ? '#6b7280' : '#e0d8c9' }} />
                        )}
                    </React.Fragment>
                );
            })}
        </div>
    );
};

export default StepIndicator;
